import { EffectiveDateFilterEnum } from '@app/app.enum';
import { IEffectiveDateFiltersProps } from '@app/models/shared.models';
import Injector from '@app/services';
import { IntlService } from '@app/services/intl.service';
import { ListItemText, MenuItem, TextField } from '@material-ui/core';
import dayjs from 'dayjs';
import React from 'react';

const intlService: IntlService = Injector.get(IntlService);
const EffectiveDateFilters = (props: IEffectiveDateFiltersProps) => {

	// Filter state for setting the select component value
	const [selectFilter, setSelectFilter] = React.useState(EffectiveDateFilterEnum.Today);

	const applyPredefinedFilters = (filterValue: EffectiveDateFilterEnum) => {
		let effectiveDate: Date = props.effectiveDate;
		switch (filterValue) {
			case EffectiveDateFilterEnum.Today:
				effectiveDate = dayjs().toDate();
				break;
			default:
				break;
		}
		setSelectFilter(filterValue);
		props.onDateChange(effectiveDate, filterValue);
	};

	return (
		<TextField
			select={true}
			variant='outlined'
			label={intlService.GetFormattedMessage('admin.account-customer-effectivedate-filter-label')}
			fullWidth={true}
			value={selectFilter}
			disabled={props.disabled}
			inputProps={{ 'data-testid': 'effectiveDateFilters' }}
			SelectProps={{
				renderValue: (selected: string[]) =>
					intlService.GetFormattedMessage(`admin.account-customer-effectivedate-filter-${selected.toString()}`),
			}}
			onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
				applyPredefinedFilters(e.target.value as EffectiveDateFilterEnum);
			}}
		>
			{Object.keys(EffectiveDateFilterEnum).map((value: EffectiveDateFilterEnum, index: number) => (
				<MenuItem key={index} value={value}>
					<ListItemText primary={intlService.GetFormattedMessage(`admin.account-customer-effectivedate-filter-${value}`)} />
				</MenuItem>
			))}
		</TextField>
	);
};

export default EffectiveDateFilters;



// WEBPACK FOOTER //
// ./src/components/shared/effectivedate-filters.component.tsx